//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';

// const typesWithNews = ['NEW_GIFT', 'LOST_GIFT']
// const typesWithMasterpiece = ['MIR_LOTTERY_WIN', 'MIR_LOTTERY_LOST']
const typesWithNews = ['MIR_LOTTERY_LOST', 'MIR_LOTTERY_WIN']
const typesWithMasterpiece = ['LOST_GIFT']
const allPatronTypes = ['NEW_GIFT', 'REFUSE_GIFT']
const getPatronTypes = ['NEW_GIFT']
const ratingsCodes = ['NEW_RATING_PATRON', 'NEW_RATING_COLLECTOR', 'NEW_RATING_SPONSOR', 'NEW_RATING_POPULAR']

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      modal: null,
      isViewed: false
    }
  },
  computed: {
    dateDiff () {
      const notification = {
        ...this.notification
      }

      const diff = moment().diff(moment.unix(notification.date), 'hour', true)

      if (diff < 1) {
        return moment.unix(notification.date).fromNow()
      } if (diff < 24) {
        return moment.unix(notification.date).calendar()
      } else {
        return moment.unix(notification.date).format('DD.MM.yyyy HH:mm')
      }
    },
    old () {
      const type = this.notification.type || {}
      let active = true
      if (getPatronTypes.includes(type.code) && !this.notification.currentOwner) {
        active = false
      } else {
        active = !this.notification.isViewed
      }
      return !active || this.isViewed
      // return moment().diff(moment.unix(this.notification.date)) > 86400000 || !active
    },
    url () {
      const type = this.notification.type || {}

      if (this.notification.linkedEntityId) {
        if (typesWithNews.includes(type.code)) {
          return `/news/${this.notification.linkedEntityId}`
        } else if (typesWithMasterpiece.includes(type.code)) {
          return `/masterpiece/${this.notification.linkedEntityId}`
        } else if (allPatronTypes.includes(type.code)) {
          return { path: this.$route.path }
        }
      }

      if (type.code === 'NEW_STATUS') {
        return '/profile/detail'
      } else if (type.code === 'NEW_AWARD') {
        return {
          path: '/profile/detail',
          hash: '#achievements'
        }
      } else if (ratingsCodes.includes(type.code)) {
        return {
          path: '/',
          hash: '#ratings'
        }
      } else if (type.code === 'MIR_OPEN') {
        return '/profile/detail#mir'
      } else if (type.code === 'MIR_LOTTERY_PARTICIPANT' && !this.notification.isViewed && !this.isViewed) {
        return '#'
      }

      return null
    },
    icon () {
      const type = this.notification.type || {}
      switch (type.code) {
        case 'NEW_RATING_COLLECTOR':
          return '/app/images/icons/notifications/art.svg'
        case 'NEW_RATING_POPULAR':
          return '/app/images/icons/notifications/gallery.svg'
        case 'NEW_RATING_SPONSOR':
          return '/app/images/icons/notifications/museum.svg'
        case 'NEW_GIFT':
        case 'NEW_RATING_PATRON':
          return '/app/images/icons/notifications/patron.svg'
      }

      return null
    }
  },
  methods: {
    click () {
      const type = this.notification.type || {}
      if (type.code === 'MIR_LOTTERY_PARTICIPANT') {
        if (!this.notification.isViewed) {
          const text = {
            ru: {
              message: 'Хотите ли вы участвовать в розыгрыше патронатов от МИРа?',
              buttonYes: 'Да',
              buttonNo: 'Нет'
            },
            en: {
              message: 'en Хотите ли вы участвовать в розыгрыше патронатов от МИРа?',
              buttonYes: 'en Да',
              buttonNo: 'en Нет'
            }
          }
          this.modal = {
            title: type.name,
            ...text[this.$i18n.locale || 'ru']
          }
          return
        } else {
          return
        }
      } else {
        this.setMessageViewed(true)
      }
    },
    clickAction() {
      const type = this.notification.type || {}
      if (getPatronTypes.includes(type.code)) {
        const { linkedEntityId, currentOwner } = this.notification
        if (currentOwner) {
          this.$store.commit('sidebars/notificationsAsideClose')
          this.$store.commit('forms/changeIdForPatronForm', {id: linkedEntityId, additional: `${currentOwner.name} ${currentOwner.lastName}`})
        }
      } else if (type.code === 'REFUSE_GIFT') {
        const { linkedEntityId, refuseGiftUserEmail } = this.notification
        this.$store.commit('sidebars/notificationsAsideClose')
        this.$store.commit('forms/changeIdForReturnPatronForm', {id: linkedEntityId, additional: {email: refuseGiftUserEmail}})
      } else if (this.url) {
        this.$router.push(this.url)
        this.$store.commit('sidebars/notificationsAsideClose')
      }
    },
    lotteryParticipant(result) {
      this.$axios({
        method: 'get',
        url: `/api/v1/personnel/${result}/?lotteryId=${this.notification.linkedEntityId}`
      })
      .then(({data}) => {
        if(data.error) {
          this.modal = {...this.modal, error: data.error.message}
        } else {
          this.modal = null
          this.setMessageViewed()
        }
      })
      .catch(err => {
        console.log('ошибка при ответе', err)
      })
    },
    setMessageViewed(next) {
      this.$axios({
        method: 'post',
        url: `/api/v1/personnel/setMessageViewed/`,
        data: `messageId=${this.notification.id}`
      })
      .then(({data}) => {
        if(!data.error) {
          this.isViewed = true
        }
      })
      .catch(err => {
        console.log('ошибка при загрузке данных', err)
      })
      .finally(data => {
        if (next) {
          this.clickAction()
        }
      })
    }
  }
}
